export default {"src":"/planos/_next/static/media/facebook-icon.466b595f.svg","height":16,"width":9,"blurWidth":0,"blurHeight":0};